import axios from 'axios';
import { auth } from './firebase';
import { getCurrentProductId } from './product';

// API base URL
const API_BASE_URL = import.meta.env.VITE_API_URL;

// Log API configuration for debugging
console.log('=== gymAhead API Configuration ===');
console.log('API Base URL:', API_BASE_URL);

// Create axios instance with default config
const api = axios.create({
  baseURL: `${API_BASE_URL}/api/v1`,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Important for cookies
});

// Add request interceptor for authentication and product context
api.interceptors.request.use(
  async (config) => {
    // Add Firebase ID token to Authorization header if user is authenticated
    try {
      const user = auth.currentUser;
      if (user) {
        const idToken = await user.getIdToken();
        config.headers.Authorization = `Bearer ${idToken}`;
        console.log('Added auth token to request:', config.url);
      } else {
        console.warn('No authenticated user found for request:', config.url);
      }
    } catch (error) {
      console.warn('Failed to get ID token:', error);
    }
    
    // Add product ID header if available
    const productId = getCurrentProductId();
    if (productId) {
      config.headers['X-Product-Id'] = productId;
    }
    
    console.log(`API Request: ${config.method?.toUpperCase()} ${config.url}`);
    return config;
  },
  (error) => {
    console.error('API Request Error:', error);
    return Promise.reject(error);
  }
);

// Add response interceptor for logging
api.interceptors.response.use(
  (response) => {
    console.log(`API Response: ${response.status} ${response.config.url}`);
    return response;
  },
  (error) => {
    console.error('API Response Error:', error.response?.data || error.message);
    
    // Handle 401/403 auth errors
    if (error.response?.status === 401 || error.response?.status === 403) {
      console.warn('Authentication error - user may need to log in');
      // Could redirect to login page here if needed
    }
    
    // Handle product access errors (403 with product context)
    if (error.response?.status === 403) {
      const detail = error.response?.data?.detail || '';
      if (detail.includes('product') && detail.includes('activate')) {
        // Product access denied - could trigger activation flow
        console.warn('Product access denied - user may need to activate product');
      }
    }
    
    return Promise.reject(error);
  }
);

export default api;

